import { render, staticRenderFns } from "./InputSeparatore2.vue?vue&type=template&id=49e3eb3a&scoped=true&"
import script from "./InputSeparatore2.vue?vue&type=script&lang=js&"
export * from "./InputSeparatore2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3eb3a",
  null
  
)

export default component.exports